import { Button } from "@/components/ui/button";
import { Container } from "@/components/Container";
import { Link } from "react-router-dom";
import { ChevronLeft, Bug } from "lucide-react";

export function ErrorElement() {
  const handleSupportClick = () => {
    window.open("https://forms.gle/Erp9LaBxJRHYybYB7", "_blank");
  };

  return (
    <Container>
      <div className="relative w-full flex flex-row justify-center items-center py-6 mb-4">
        <Link className="absolute left-0" to="/">
          <Button
            className="hidden sm:flex flex-row gap-x-2 text-primary"
            variant="ghost"
          >
            <ChevronLeft /> Back
          </Button>
        </Link>
      </div>

      <main className="grid min-h-[calc(100vh-200px)] place-items-center px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-destructive">Error</h2>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-primary sm:text-5xl">
            Something went wrong
          </h1>
          <p className="mt-6 text-base leading-7 text-muted-foreground">
            Sorry, we encountered an error while processing your request.
          </p>
          <p className="mt-2 text-sm text-muted-foreground">
            If this issue persists, please help us improve by filing a bug
            report. Your feedback is valuable to us.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button asChild>
              <Link to="/">Go back home</Link>
            </Button>
            <Button
              variant="outline"
              onClick={handleSupportClick}
              className="flex items-center gap-2"
            >
              <Bug size={16} />
              Report this issue
            </Button>
          </div>
        </div>
      </main>
    </Container>
  );
}
